// extracted by mini-css-extract-plugin
module.exports = {"floating-toc":"floating-toc_floating-toc__dxBlY","scrollable-el":"floating-toc_scrollable-el__rhqgZ","item":"floating-toc_item__yCpzf","selected":"floating-toc_selected__lZC6I"};